import React from 'react';

const InfoImg = (props: { src: string; alt: string }) => {
  const { src, alt } = props;

  return <img src={src} alt={alt} className="w-full rounded-md" />;
};

export default InfoImg;
